import { render, staticRenderFns } from "./VisitInfo.vue?vue&type=template&id=84d5ff1e"
import script from "./VisitInfo.vue?vue&type=script&lang=js"
export * from "./VisitInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports